//import MessagesService from 'js/services/api/citizen/messages'
import {mapActions} from 'vuex'
import MessagePanel from './_message-panel'
import ChatPanel from './_chat-panel'

import template from './index.pug'
import MessageCard from '../index/_message-card'

// @vue/component
export default {
  name: 'citizen-messages-show',
  template: template(),

  components: {MessagePanel, ChatPanel,MessageCard},

  data() {
    return {
      messages:[],
    }
  },

  computed: {
    messageId() {
      return this.$route.params.id
    },

  },

  created() {
   
    if (!this.messageId || this.messageId === 'new') {
      this.$router.push({name: 'municipality-menu'})
    }
    this.searchMessage()
  },

  methods: {
    async searchMessage(){
     
      const BASE_URL = 'citizen/messages'
      const params = {
        template: "client_show"
      }
      this.messages =  await Vue.http.get(BASE_URL, {params, skipLoading: true}).then(response => response.data.data)
     
    },
   
  }
}
